import axios from 'axios';
import { useEffect, useRef, useState } from 'react';

import $ from 'jquery';

import { Close, DirectionsCar as Car, DirectionsWalk as Walk, GridOff, GridOn, MapsHomeWork as House } from '@mui/icons-material';
import { Radio } from '@mui/material';

// OpenLayers
import 'ol/ol.css';
import Collection from 'ol/Collection';
import { defaults as defaultControls } from 'ol/control';
import Feature from 'ol/Feature';
import GeoJSON from 'ol/format/GeoJSON';
import { defaults as defaultInteractions } from 'ol/interaction';
import { Image as ImageLayer,  Tile as TileLayer, Vector as VectorLayer } from 'ol/layer';
import Map from 'ol/Map';
import Overlay from 'ol/Overlay';
import Point from 'ol/geom/Point';
import { ImageStatic, Vector as VectorSource, XYZ } from 'ol/source';
import { Icon, Fill, Stroke, Style, Text} from 'ol/style';
import { fromLonLat } from "ol/proj";
import View from 'ol/View';

import fallLegend from './json/fallLegend.json';
import thrLegend from './json/thrLegend.json';
import underLoad from './json/gangwon_under.json';

import { ReactComponent as IconCalendar } from './images/icon_calendar.svg';
// import { ReactComponent as IconObs } from './images/icon_obs.svg';
// import { ReactComponent as IconPre } from './images/icon_pre.svg';
// import { ReactComponent as IconRoad } from './images/icon_road.svg';
import { ReactComponent as IconSatellite } from './images/icon_satellite.svg';
import { ReactComponent as IconTunnel } from './images/icon_tunnel.svg';
import { ReactComponent as IconRainfall } from './images/icon_rainfall.svg';

import Curtain from './library/CurtainBody';
import Highchart1 from './library/Highchart1';
import Highchart2 from './library/Highchart2';
import VideoPlayer from './library/VideoPlayer';

import style from './Intro.module.css';

function Intro() {

    const baseCenter = [129.300000000, 37.850000000];
    const fallCenter = [128.175000000, 35.900000000];
    // const key = 'D2F590DE-63F4-34A1-B061-460E1882C00E'   // 테스트 개발키;
    const key = '0D7CC4AE-A79D-37A3-87D1-7108BFDA38DF'      // 강원대 운영키;

    // 큰 지도 시작
    const baseFillLayer = new VectorLayer({
        id: 'baseFill', name: 'isBaseFill',
        source: new VectorSource({ url: '/data/geoJSON/korea_wide_09.geojson', format: new GeoJSON() }),
        style: new Style({ fill: new Fill({ color: '#333' }) }),
        zIndex: 10
    });

    // 위성 사진
    const [satelliteLayer] = useState(new TileLayer({
        id: 'satellite', name: 'isSatellite',
        source: new XYZ({ url: 'http://api.vworld.kr/req/wmts/1.0.0/' + key +'/Satellite/{z}/{y}/{x}.jpeg' }),
        zIndex: 15
    }));

    const [basisLayer] = useState(new VectorLayer({
        id: 'basisLayer', name: 'isBasisLayer', opacity: 0,
        source: new VectorSource({ url: '/data/geoJSON/gangwon_basis_18.geojson', format: new GeoJSON() }),
        zIndex: 20
    }));

    const [TBLayer] = useState(new VectorLayer({
        id: 'TBLayer', name: 'isTBLayer', opacity: 0,
        source: new VectorSource({ url: '/data/geoJSON/gangwon_TB.geojson', format: new GeoJSON() }),
        zIndex: 20
    }));

    // 1km 격자 이미지 구역_YYYYMMDDHH_지역코드_READTIME.png
    const [grid1kmLayer] = useState(new ImageLayer({
        id: 'grid1kmLayer', name: 'isGrid1kmLayer', opacity: .5,
        source: new ImageStatic({ crossOrigin: '', imageExtent: [], projection: 'EPSG:4326' }),
        zIndex: 25
    })); 

    const [baseRoadLayer] = useState(new VectorLayer({
        id: 'baseRoad', name: 'isBaseRoad',
        source: new VectorSource({ url: '/data/geoJSON/gangwon_road.geojson', format: new GeoJSON() }),
        style: new Style({ stroke: new Stroke({ width: 0.5, color: '#333333' }) }),
        zIndex: 30
    }));

    // mouse move, click etc.. ghost layer
    const [TBStroke] = useState(new VectorLayer({    
        id: 'TBStroke', name: 'isTBStroke', opacity: 0,
        source: new VectorSource({ url: '/data/geoJSON/gangwon_TB.geojson', format: new GeoJSON() }),
        zIndex: 40
    }));

    const [basisStroke] = useState(new VectorLayer({    
        id: 'basisStroke', name: 'isBasisStroke', opacity: 0,
        source: new VectorSource({ url: '/data/geoJSON/gangwon_basis_18.geojson', format: new GeoJSON() }),
        zIndex: 40
    }));

    const wideStroke = new VectorLayer({
        id: 'wideStroke', name: 'isWideStroke',
        source: new VectorSource({ url: '/data/geoJSON/korea_wide_17.geojson', format: new GeoJSON() }),
        style: new Style({ stroke: new Stroke({ width: 1.75, color: [254, 96, 0, .75] }) }),
        zIndex: 50
    });

    const featureArray = [];
    for (let i = 0; i < underLoad.length; i ++) featureArray.push(new Feature({ geometry: new Point(fromLonLat(underLoad[i].coordinates)) }));
   
    const [baseUnderLayer] = useState(new VectorLayer({
        id: 'baseUnder', name: 'isBaseUnder',
        source: new VectorSource({ features: featureArray }),
        style: new Style({
            image: new Icon({ 
                opacity: 1, scale: 1, 
                src: 'http://map.vworld.kr/images/ol3/marker_blue.png'
                // src: '/images/marker_camera.png'
            }),
            zindex: 10
        }),
        zIndex: 70
    }));

    const [baseAwsLayer, setBaseAwsLayer] = useState(new VectorLayer());    // AWS Layer

    const [cctvLayer, setCctvLayer] = useState(new VectorLayer());         // CCTV Layer

    const [northStroke] = useState(new VectorLayer({
        id: 'northStroke', name: 'isNorthStroke',
        source: new VectorSource({ url: '/data/geoJSON/north_korea.geojson', format: new GeoJSON() }),
        style: new Style({
            fill: new Fill({ color: '#202124' }), 
            stroke: new Stroke({ width: 1.75, color: [254, 96, 0, .75] })
        }),
        zIndex: 70
    }));

    const features = [
        /*{ 
            color: [192, 192, 240, .5], font: 'bold 21px Arial',
            geometry: new Point([14167500, 4670000]), text: 'North Korea' 
        },*/
        { 
            color: [241, 159, 25, .75], font: "bold italic 21px 'Noto Sans KR'",
            geometry: new Point([14410000, 4550000]), text: 'East Sea' 
        }
    ];    
    const eastSea = new VectorLayer({
        id: 'eastSea', name: 'isEastSea',
        source: new VectorSource({
            features: new Collection(
                features.map((featureOptions) => {
                    const feature = new Feature({ geometry: featureOptions.geometry  });
                    feature.setStyle(createStyle(featureOptions));
                    return feature;
                })
            ),
            format: new GeoJSON(),
        }),
        zIndex: 80
    });

    function createStyle({text, color, font}) {
        return new Style({
            text: new Text({
                fill: new Fill({ color: color }), font: font,
                padding: [2, 2, 2, 2], text: text
            }),
        });
    }
    // 큰 지도 종료

    // 작은 지도 시작
    const fallFillLayer = new VectorLayer({
        id: 'fallFill', name: 'isFallFill',
        source: new VectorSource({ url: '/data/geoJSON/korea_entire.geojson', format: new GeoJSON() }),
        style: new Style({ fill: new Fill({ color: '#888' }) }),
        zIndex: 10
    });

    const fallGangwoFill = new VectorLayer({
        id: 'fallGangwonFill', name: 'isFallGangwonFill',
        source: new VectorSource({ url: '/data/geoJSON/gangwon_wide.geojson', format: new GeoJSON() }),
        style: new Style({ fill: new Fill({ color: '#CCC' }) }),
        zIndex: 20
    });

    const fallStrokeLayer = new VectorLayer({
        id: 'fallStroke', name: 'isFallStroke',
        source: new VectorSource({ url: '/data/geoJSON/korea_entire.geojson', format: new GeoJSON() }),
        style: new Style({ stroke: new Stroke({ width: 1, color: [30, 80, 255, .25] }) }),
        zIndex: 30
    });

    const fallNorthLayer = new VectorLayer({
        id: 'fallNorth', name: 'isFallNorth',
        source: new VectorSource({ url: '/data/geoJSON/north_korea.geojson', format: new GeoJSON() }),
        style: new Style({
            fill: new Fill({ color: '#333' }), 
            stroke: new Stroke({ width: 1, color: [30, 80, 255, .25] })
        }),
        zIndex: 30
    });

    const [actionLayer] = useState(new ImageLayer({
        id: 'fallAction', name: 'isFallAction', opacity: 0.5, 
        source: new ImageStatic({ crossOrigin: '', imageExtent: [], projection: 'EPSG:4326' }),
        zIndex: 40
    })); // 관측, 예측 표현 레이어

    const fallGangwoStroke = new VectorLayer({
        id: 'fallGangwonStroke', name: 'isFallGangwonStroke',
        source: new VectorSource({ url: '/data/geoJSON/gangwon_wide.geojson', format: new GeoJSON() }),
        style: new Style({
            stroke: new Stroke({ width: 1.75, color: [254, 96, 0, .75] })
        }),
        zIndex: 50
    });

    // 작은 지도 종료

    // 공통 지도 시작
    const japanLayer = new VectorLayer({ // 큰 지도에는 필요가 없어서 적용 안함
        id: 'japanBoundary', name: 'isJapanBoundaryLayer',
        source: new VectorSource({ url: '/data/geoJSON/japan.geojson', format: new GeoJSON() }),
        style: new Style({
            fill: new Fill({ color: '#333' }),
            stroke: new Stroke({ width: 1, color: [30, 80, 255, .25] }) 
        }),
        zIndex: 5
    });
    // 공통 지도 종료
    
    const [baseGround, setBaseGround] = useState(new Map());    // Base 지도에 사용
    const [fallGround, setFallGround] = useState(new Map());    // Fall 지도에 사용

    const [allData, setAllData] = useState({})                  // 행정, 특보 구역 모든 informaion
    const [infoData, setInfoData] = useState([])                // 선택된 information
    const [infoCode, setInfoCode] = useState('42000')           // 시군구 information code, default 42000 = 강원 전체
    
    // 발표시간 min max 정보
    // {max_date: '2023-07-03', min_date: '2023-07-03', max_time: '09:00:00', min_time: '09:00:00'}
    const [crtnMinMax, setCrtnMinMax] = useState({});

    // 선택 발표시간 정보
    // {date: '2023-07-03', time: '09:00:00'}
    const [crtn, setCrtn] = useState({ });

    // 선행일시
    // {date: '2023-07-03', time: '09:00:00'}
    const [fcst, setFcst] = useState({ });
    const [areaData, setAreaData] = useState({});               // 강원 행정, 특보 위험도 데이터
    const [playAction, setPlayAction] = useState(false);
    const playIntervalRef = useRef(null);

    const [pcpData, setPcpData] = useState({});                 // 예측 강우량
    //const [thrData, setThrData] = useState({thr1: {}, thr2: {}, thr3: {}}); // 한계 강우량

    const [spotPosition, setSpotPosition] = useState(5);        // 삼각형 꼭지 가로 위치 px임
    const [pointTime, setPointTime] = useState(0);              // 시점 0 ~ pointTimeMax
    const pointTimeMax = 23;                                    // 타임 슬라이드 최대 시간, 48시간이 최대 임
    
    // 지도 toggle {satellite: 위성사진, road: 도로, under: 지하차도 }
    const [mapSwitch, setMapSwitch] = useState({ satellite: false, road: false, under: false });
    const [fallWall, setFallWall] = useState(false)             // 우량주상도 Open and close
    // const [currentStatus, setCurrentStatus] = useState(0)    // 예측, 관측 전환 {0: 관측, 1: 예측}
    const [currentStatus] = useState(0)                         // 예측, 관측 전환 {0: 관측, 1: 예측}
    const [gridBoolean, setGridBoolean] = useState(false)       // 1km 격자 이미지 상턔
    
    const [area, setArea] = useState('SGG');                    // SGG: 행정 구역, TB: 특보 구역
    const [floodData, setFloodData] = useState({})              // 침수 위험 지역 data

    const [loading, setLoading] = useState(false)               // loading....
    
    // CCTV choice
    const [cctv, setCctv] = useState({ lat: 0.0, lon: 0.0, name: '', road: '', view: '' })
    const [cctvData, setCctvData] = useState([])                // CCTV data
    const [cctvValue, setCctvValue] = useState(0)               // CCTV value
    const [cctvUrl, setCctvUrl] = useState(null)                // CCTV url
    const [cctvName, setCctvName] = useState('')                // CCTV Name

    useEffect(() => {
        // console.log(thrLegend);
        // 큰 지도 시작
        setBaseGround(() => new Map({
            controls: defaultControls({ zoom: false, rotate: false }),
            layers: [ 
                baseFillLayer, satelliteLayer, grid1kmLayer, wideStroke, 
                basisLayer, basisStroke, TBLayer, TBStroke,
                northStroke, eastSea, cctvLayer
            ],
            interactions: defaultInteractions({ 
                altShiftDragRotate: false, doubleClickZoom: false, dragPan: false, mouseWheelZoom: false,
                pinchRotate: false, pinchZoom: false, shiftDragZoom: false
            }), target: 'base_map', 
            view: new View({
                center: fromLonLat(baseCenter),
                maxZoom: 20, minZoom: 0, zoom: 9.25
            })
        }));
        // 큰 지도 종료

        // 작은 지도 시작
        setFallGround(() => new Map({
            controls: defaultControls({ zoom: false, rotate: false }),
            layers: [ 
                japanLayer,         // 일본
                fallFillLayer,      // 남한 배경색
                fallGangwoFill,     // 강원도 배경색
                fallStrokeLayer,    // 남한 경계선
                fallNorthLayer,     // 북한
                actionLayer,
                fallGangwoStroke    // 강원도 경계선
            ],
            interactions: defaultInteractions({ 
                altShiftDragRotate: false, doubleClickZoom: false, dragPan: false, mouseWheelZoom: false,
                pinchRotate: false, pinchZoom: false, shiftDragZoom: false
            }),
            target: 'fall_map', 
            view: new View({
                center: fromLonLat(fallCenter),
                maxZoom: 20, minZoom: 0, zoom: 6.85
            })
        }));
        // 작은 지도 종료

        // 행정 및 특보 구역 정보 2024 추가
        axios.post(window.API_URL + '/Intro/getAreaInfo')
        .then(results => {
            try {
                setAllData(results.data);
            }
            catch(e) {
                console.log(e)
            }
        });

        // Get TFFS_MINMAXDATE
        axios.post(window.API_URL + '/Intro/getTffsMinMaxDate')
        .then(results => {
            try {
                setCrtnMinMax(results.data);
                setCrtn({ date: results.data.max_date, time: results.data.max_time });
            }
            catch(e) {
                console.log(e)
            }
        });

        // Get AWS information
        axios.post(window.API_URL + '/Intro/getAWSinfo')
        .then(results => {
            try {
                const featureArray = [];
                for (let i = 0; i < results.data.length; i ++) featureArray.push(new Feature({ 
                    altitude : results.data[i].altitude, id: results.data[i].id, name: results.data[i].designate, 
                    geometry: new Point(fromLonLat(results.data[i].coordinates))
                }));

                setBaseAwsLayer(new VectorLayer({
                    id: 'baseAws', name: 'isBaseAws',
                    source: new VectorSource({ features: featureArray }),
                    style: new Style({
                        image: new Icon({ 
                            anchor: [0.5, 0.96], opacity: 1, scale: .5, 
                            src: './images/marker_aws.png'
                        }),
                        zindex: 10
                    }),
                    zIndex: 70
                }))
            }
            catch(e) {
                console.log(e);
            }
        });

        // Get CCTV
        axios.post(window.API_URL + '/Intro/getCCTVInfo')
        .then(results => {
            try {
                setCctvData(results.data);
                setCctv({ ...cctv, 
                    lat: results.data[0].lat, 
                    lon: results.data[0].lon,
                    name: results.data[0].name,
                    road: results.data[0].road,
                    view: results.data[0].view 
                });
            }
            catch(e) {
                console.log(e)
            }
        });

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (Object.keys(allData).length > 0) {
            setInfoData(allData[area]);
        }
    }, [allData, area, infoData]);

    useEffect(() => {
        if (baseGround && Object.keys(areaData).length > 0) {
            if (basisLayer.getOpacity() === 0) {
                basisLayer.setOpacity(1);
                basisStroke.setOpacity(1);
                TBLayer.setOpacity(1);
                TBStroke.setOpacity(1);
            }

            if (area === 'SGG') {
                if (TBLayer.getVisible() === true) {
                    TBLayer.setVisible(false);
                    TBStroke.setVisible(false);
                }

                if (gridBoolean === true) {
                    TBStroke.setVisible(false);
                    basisLayer.setVisible(false);
                }
                else basisLayer.setVisible(true);
                basisStroke.setVisible(true);
            }
            else {
                if (basisLayer.getVisible() === true) {
                    basisLayer.setVisible(false);
                    basisStroke.setVisible(false);
                }

                if (gridBoolean === true) {
                    basisStroke.setVisible(false);
                    TBLayer.setVisible(false);
                }
                else TBLayer.setVisible(true);
                TBStroke.setVisible(true);
            }
        }
    }, [area, areaData, baseGround, basisLayer, basisStroke, gridBoolean, TBLayer, TBStroke]);

    useEffect(() => {
        // Marker mouse pointer change
        baseGround.on('pointermove', function (event) {
            if (playIntervalRef.current === null) {
                if (event.dragging) return;
                const pixel = event.map.getEventPixel(event.originalEvent);
                const hit = event.map.forEachFeatureAtPixel(pixel, function (feature) { 

                    let boolean = true;

                    // console.log(feature);
                    if (area === 'SGG') {
                        if (feature.get('ADM_SECT_C') === undefined) boolean = false; 
                    }
                    else {
                        if (feature.get('regid') === undefined) boolean = false; 
                    }
                    return boolean;
                });
                baseGround.getViewport().style.cursor = (hit) ? 'pointer' : '';
            }
        });
        
        // Marker click start && 1km grid
        baseGround.on('singleclick', function (event) {
            try {    
                if (playIntervalRef.current === null) {
                    const pixel = event.map.getEventPixel(event.originalEvent);
                    const feature = event.map.forEachFeatureAtPixel(pixel, function (feature, layer) { return feature; });

                    if (feature.get('kind') || feature.get('ADM_SECT_C') || feature.get('regid')) {
                        if (feature.get('kind') === 'camera') {
                            setLoading(true);

                            axios.post(window.API_URL + '/Intro/getCCTVurl', null, 
                            { params: { lat: feature.get('lat'), lon: feature.get('lon'), type: feature.get('road') }})
                            .then(results => {
                                try {
                                    setCctvName(feature.get('name'));
                                    setCctvUrl(results.data.cctvurl);
                                    setLoading(false)
                                }
                                catch(e) {
                                    console.log(e)
                                }
                            });
                        }
                        else {
                            let code;
                            if (area === 'SGG' && feature.get('ADM_SECT_C')) code = feature.get('ADM_SECT_C');
                            else if (area === 'TB' && feature.get('regid')) code = feature.get('regid');

                            setInfoCode(code);
                            if (gridBoolean === false && code !== '42000') {
                                const overlay = new Overlay({
                                    element:  document.getElementById('popup'),
                                    offset: [0, 0]
                                });
                            
                                baseGround.addOverlay(overlay);
                                overlay.setPosition(event.coordinate);
                                $('#popup').show();
                            }
                        }
                    }
                }
            }    
            catch(e) {
                console.log(e);
            }
        });
    }, [area, baseGround, gridBoolean, playIntervalRef]);

    useEffect(() => { // 행정 구역 레이어 색상 변경
        if (Object.keys(areaData).length > 0) {
            basisLayer.setStyle((feature) => {
                const fillColor = areaData[feature.get('ADM_SECT_C')][pointTime];
                
                return new Style({ fill: new Fill({ color: fillColor }) })
            });
        }
    }, [areaData, basisLayer, pointTime]);

    useEffect(() => { // 특보 구역 레이어 색상 변경
        if (Object.keys(areaData).length > 0) {
            TBLayer.setStyle((feature) => {
                const fillColor = areaData[feature.get('regid')][pointTime];
                    
                return new Style({ fill: new Fill({ color: fillColor }) })
            });
        }
    }, [areaData, pointTime, TBLayer]);

    useEffect(() => { // 위성 사진
        if (mapSwitch.satellite === true) {
            // console.log(northStroke.getStyle());
            northStroke.setStyle(() => {
                return new Style({
                    fill: new Fill({ color: 'transparent' }), 
                    stroke: new Stroke({ width: 1.75, color: [254, 96, 0, .75] })
                })
            });

            let boolean = true;
            baseGround.getLayers().forEach(layer => {
                if (layer.get('name') === 'isSatellite') {
                    boolean = false;
                    return;
                }
            });
            if (boolean === true) baseGround.addLayer(satelliteLayer);
        }
        else {
            baseGround.removeLayer(satelliteLayer);

            northStroke.setStyle(() => {
                return new Style({
                    fill: new Fill({ color: '#202124' }), 
                    stroke: new Stroke({ width: 1.75, color: [254, 96, 0, .75] })
                })
            });
        }
    }, [baseGround, northStroke, satelliteLayer, mapSwitch.satellite]);

    useEffect(() => { // 도로
        if (mapSwitch.road === true) {
            let boolean = true;
            baseGround.getLayers().forEach(layer => {
                if (layer.get('name') === 'isBaseRoad') {
                    boolean = false;
                    return;
                }
            });
            if (boolean === true) {
                baseGround.addLayer(baseRoadLayer);
                baseGround.addLayer(baseUnderLayer);
            }
        }
        else {
            baseGround.removeLayer(baseRoadLayer);
            baseGround.removeLayer(baseUnderLayer);
        }
    }, [baseGround, baseRoadLayer, baseUnderLayer, mapSwitch.road]);

    useEffect(() => { // 지하차도
        if (mapSwitch.under === true) baseGround.addLayer(baseUnderLayer);
        else baseGround.removeLayer(baseUnderLayer);
    }, [baseGround, baseUnderLayer, mapSwitch.under]);
    
    useEffect(() => { // currentStatus {0: 예측, 1: 관측}
        if (currentStatus === 0) baseGround.removeLayer(baseAwsLayer);
        else baseGround.addLayer(baseAwsLayer);
    }, [baseGround, baseAwsLayer, currentStatus]);

    useEffect(() => { // 행정 구역 시군 경계선, 시군명

        basisStroke.setStyle((feature) => { 
                
            return new Style({
                fill: new Fill({ color: 'transparent' }), 
                stroke: new Stroke({ width: 2, color: [30, 80, 255, .75] }),
                text: new Text({
                    fill: new Fill({ color: '#333' }),
                    scale: 1.22,
                    text: feature.get('SGG_NM'),
                })
            })

        });
    }, [basisStroke]);

    useEffect(() => {
        if (cctv.name) {
            baseGround.removeLayer(cctvLayer);
            
            const feature = [new Feature({ 
                geometry: new Point(fromLonLat([cctv.lon, cctv.lat])),
                kind: 'camera', lat: cctv.lat, lon: cctv.lon, 
                name: cctv.name, road: cctv.road, view: cctv.view
            })]; 

            setCctvLayer(new VectorLayer({
                id: 'cctvLayer', name: 'isCctvLayer',
                source: new VectorSource({ features: feature }),
                style: cctvStyle, zIndex: 70
            }))
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cctv]);

    useEffect(() => {
        baseGround.addLayer(cctvLayer);

    // eslint-disable-next-line react-hooks/exhaustive-deps    
    }, [cctvLayer])

    /* 
     * Small map Actions Start
     * currentStatus {0: 예측, 1: 관측} 
     */
    useEffect(() => {
        if (Object.keys(crtn).length > 0) { 
            let pathText = crtn.date.replace(/-/g, '');
            const target = (currentStatus === 0) ? 'PRE': 'OBS';
            let url = '/data/' + target + '/' + pathText.substr(0, 6) + '/' +  pathText.substr(6, 2)  +'/';
            url += target +'_'+ pathText + crtn.time.substr(0,2);
            if (currentStatus === 0) url+= '_' + pointTime.zero(2); // 예측일때
            url+= '.png';
            
            const extentSpot = window.ExtentSpot
            const option = { 
                extent: (currentStatus === 0) ? extentSpot.PRE : extentSpot.OBS,
                opacity: .5, zIndex: 40 
            };

            const source = new ImageStatic({ crossOrigin: '', imageExtent: option.extent, projection: 'EPSG:4326', url: url });

            actionLayer.setSource(source);
        }
    }, [actionLayer, crtn, currentStatus, pointTime]);

    useEffect(() => {   // 관심, 주의, 경고, 위험 카운트 값
        if (crtn.date && crtn.time) {
            // ★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★
            // 이부분이 까리 함 일단 막고 보자
            // setFcst({ date: crtn.date, time: crtn.time });
            // ★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★
            
            axios.post(window.API_URL + '/Intro/getAreaData', null, { params: { crtn: crtn.date + ' ' + crtn.time }})
            .then(results => {
                try {
                    setAreaData(results.data.HEX);
                    setPcpData(results.data.pcp);
                    //setThrData({thr1: results.data.thr1, thr2: results.data.thr2, thr3: results.data.thr3 })
                }
                catch(e) {
                    console.log(e)
                }
            });

            if (gridBoolean === true) {
                const sauce = crtn.date.replace(/-/g, '');
                const path = './data/GRJ/' + sauce.substr(0, 6) + '/' + sauce.substr(6, 2) + '/GRJ_' + sauce + crtn.time.substr(0, 2) + '.json';

                fetch(path)
                .then((response) => {
                    return response.json();
                })
                .then(data =>{
                    const code = (area === 'TB' && infoCode === '42000') ? 'L1020000' : infoCode;
                    setFloodData(data[area][code]);
                })
                .catch((e) => console.log(e));
            }
            else {
                axios.post(window.API_URL + '/Intro/getFloodData', null, { 
                    params: { 
                        crtn: crtn.date + ' ' + crtn.time,
                        infoCode: infoCode
                    }
                })
                .then(results => {
                    try {
                        setFloodData(results.data[area]);
                    }
                    catch(e) {
                        console.log(e)
                    }
                });
            }
        }
    }, [area, infoCode, crtn, gridBoolean]);

    useEffect(() => {   // 1km grid image
        if (gridBoolean === true) {
            const pathText = crtn.date.replace(/-/g, '');

            let prefix = area;
            if (prefix === 'TB' && infoCode === '42000') prefix = 'SGG';
            const url = '/data/GRD/' + pathText.substr(0, 6) + '/' +  pathText.substr(6, 2)  +'/'
                      + prefix +'_'+ pathText + crtn.time.substr(0,2) + '_' + infoCode + '_' + pointTime.zero(2) +'.png';
                
            const source = new ImageStatic({ crossOrigin: '', imageExtent: window.ExtentSpot.GRD, projection: 'EPSG:4326', url: url });
            grid1kmLayer.setSource(source);

        }
        else grid1kmLayer.setSource(null);

    }, [area, crtn, gridBoolean, grid1kmLayer, infoCode, pointTime]);

    useEffect(() => {   // 삼각형 이동
        setSpotPosition((pointTime === 0) ? 10 : (21.75 * pointTime) + 10);

        const changeDate =  new Date(crtn.date + ' ' + crtn.time);
        changeDate.setHours(changeDate.getHours() + pointTime);
        setFcst({ date: changeDate.format('Y-m-d'), time: changeDate.format('h:i:s') });
    }, [crtn, pointTime]);

    useEffect(() => {}, [fallGround]);

    useEffect(() => {   // 특보 구역 경계선, 특보 구역명
        TBStroke.setStyle((feature) => {
            return new Style({
                fill: new Fill({ color: 'transparent' }), 
                stroke: new Stroke({ width: 2, color: [30, 80, 255, .75] }),
                text: new Text({
                    fill: new Fill({ color: '#333' }),
                    scale: 1.22,
                    text: feature.get('regko')
                })
            })
            
        });
    }, [TBStroke]);

    useEffect(() => {}, [pcpData]);

    const SelectTime = () => {
        if (crtn.date && crtn.time) {
            // console.log(crtn);
            // console.log(crtnMinMax);
            // const lastTime = (crtnMinMax.max_date === crtn.date && crtnMinMax.max_time <= crtn.time) ? parseInt(crtn.time.substr(0,2)) : 21;
            const lastTime = (crtnMinMax.max_date === crtn.date) ? parseInt(crtnMinMax.max_time) : 21;

            const option = [];
            for (let i = 3; i <= lastTime; i = i + 6) option.push(<option key={ i } value={ i.zero(2) + ':00:00' }>{ i.zero(2) }시</option>)
            
            return (
                <select id={ style.gfas_sd_select } defaultValue={ crtn.time } readOnly
                onChange={(e) => { setCrtn({ ...crtn, time: e.target.value }) }}>
                    { option }
                </select>
            )
        }
    }

    const SelectCctv = () => {
        if (cctvData.length > 0) {
            const option = [];

            for (let i = 0; i < cctvData.length; i++) {
                let row = cctvData[i];
                option.push(<option key={ i } value={ i }>{ row.name }</option>)
            }
        

            return (
                <select id={ style.gfas_cb_select } defaultValue={ cctvValue || '' } readOnly
                onChange={(e) => { 
                    const value = e.target.value;
                    
                    setCctvValue(value);
                    setCctv({ ...cctv, 
                        lat: cctvData[value].lat, 
                        lon: cctvData[value].lon, 
                        name: cctvData[value].name, 
                        road: cctvData[value].road, 
                        view: cctvData[value].view
                    });
                }}>
                    { option }
                </select>
            )
        }
    }

    const Graduation = () => {
        const liArray = [];
        const startDate = new Date(crtn.date + ' ' + crtn.time);
        for (let i = 0; i < pointTimeMax; i ++) {
            const stepTime = startDate.setHours(startDate.getHours() + 1) ;
            liArray.push(
                <li key={ i } title={ new Date(stepTime).format('Y-m-d h') + '시로 이동' } value={ i } 
                onClick={(e) => { if (playAction === false) setPointTime(e.target.value) }}>|</li>
            );
        }

        return(
            <ul id={ style.gfas_pb_sc_grad }>{ liArray }</ul>
        )
    }

    const AreaSelect = () => {
        // { infoData.map((row, i) => (<option key={i}>{ row.NAME }</option>))}
        const optionArray = [];
        if (Object.keys(infoData).length > 0) {
            const index = Object.keys(infoData);
            for (let i = 0; i < Object.keys(infoData).length; i ++) {
                const row = infoData[index[i]];
                optionArray.push(<option key={i} value={ index[i] }>{ row.NAME }</option>)
            }
            
            return (
                <select id={ style.gfas_Sit_select } defaultValue={ infoCode } element="gfas_Sit_select"
                onChange={(e) => { 
                    setInfoCode(e.target.value); 
                    closePopup();
                }}>
                    { optionArray }
                </select>
            )
        }
    }

    // Fall legend
    const FallLegend = () => {
        const html = fallLegend.map((row, num) => ( 
            <li key={ num } style={{ backgroundColor: row.color }}>
                <div>{ row.text }</div>
            </li> 
        ))

        return (
            <ul id={ style.gfas_fl_ul }>{ html } </ul>
        )
    }

    // Play start
    const clockPlayStart = () => {
        let c = pointTime;
        playIntervalRef.current = setInterval(() => {
            c = c + 1;
            if (c === pointTimeMax) c = 0;
            setPointTime(c)
        }, 2000);
    }

    const clockPlayStop = () => {
        clearInterval(playIntervalRef.current);
        playIntervalRef.current = null;
    }

    function cctvStyle(feature, resolution) {
        console.assert(feature, resolution);

        const style = new Style({ 
            image: new Icon({ 
                anchor: [0, 0], anchorXUnits: 'pixels', anchorYUnits: 'pixels', 
                scale: 0.5, src: '/images/marker_cross.png' 
            }),
            text: new Text({ 
                backgroundFill: new Fill({ color: 'rgba(0, 0, 0, 0)' }), backgroundStroke: new Stroke({ color: 'rgba(0, 0, 0, 0)' }),
                fill: new Fill({ color: 'black' }), font: '13px \'Noto Sans KR\'', offsetX: 0, offsetY: 30, padding: [3, 4, 1, 5], 
                scale: 1, textAlign: 'center', text: cctv.name 
            })
        });

        return style;
    }

    function procCctvUrl() { 
        setCctvUrl(null);
    }

    function closePopup() {
        if ($('#popup').css('display') === 'block') {
            $('#popup').hide();
            baseGround.removeOverlay();
        }
    }

    return (<>
        <section id={ style.gfas_contents_section }>
            <Curtain />

            <div id="base_map" className={ style.gcs_class_base_map }></div>

            <div id="fall_map" className={ style.gcs_class_fall_map }></div>

            { /* fall_map title start */ }
            {<>
                <div id={ style.gfas_fallmap_title }>
                    { new Date(fcst.date + ' ' + fcst.time).format('Y년 m월 d일 h시') }&nbsp;
                    { currentStatus === 0 ? '예측강우' : '관측강우' }
                </div> 
                <span id={ style.gfas_fallmap_source }>자료출처: 기상청 { currentStatus === 0 ? '국지예보모델(LDAPS)' : '관측자료' }</span>
            </>}
            { /* fall_map title finish */ }

            { /* Search time and slider on header start */ 
            fallWall === false && <>
                <table id={ style.gfas_search_date } className={ style.gfas_class_header_box }>
                    <tbody>
                    <tr>
                        <td className={ style.gfas_class_hb_td_type_01 }>발표일시:</td>
                        <td>
                            <input type="date" id={ style.gfas_sd_input } max={ crtnMinMax.max_date } min={ crtnMinMax.min_date }
                            value={ crtn.date || '' } onChange={(e) => { setCrtn({ ...crtn, date: e.target.value }) }} />
                        </td>
                        <td>
                            <button id={ style.gfas_sd_calendarButton } element="calendarButton"><IconCalendar id={ style.gfas_sd_iconCalendar }/></button>
                        </td>
                        <td className={ style.gfas_class_hb_td_type_02 }><SelectTime /></td>
                        <td className={ style.gfas_class_hb_td_type_01 }>예보일시:</td>
                        <td>{ fcst.date + ' ' + fcst.time }</td>
                    </tr>
                    </tbody>
                </table>

                { currentStatus === 0 &&
                    <div id={ style.gfas_progress_bar }>
                        <button id={ style.gfas_pb_button } className={ playAction === true ? style.gfas_class_play_on : style.gfas_class_play_off }
                        onClick={() => { 
                            setPlayAction(playAction === true ? false : true); 
                            if (playIntervalRef.current === null) clockPlayStart();
                            else clockPlayStop();
                        }}/>

                        <div id={ style.gfas_pb_slider_conteiner }>
                            <span id={ style.gfas_pb_sc_spot } element="gfas_pb_sc_spot" style={{ left: `${spotPosition}px` }}>▼</span>
                            <div id={ style.gfas_pb_sc_bar } />
                            <Graduation />
                        </div>
                    </div>
                }
            </>
            /* Search time and slider on header finish */ }

            { /* Local public information start */
            Object.keys(infoData).length > 0 &&
                <div id={ style.gfas_SGG_info }>
                    <table id={ style.gfas_Si_table }>
                        <thead>
                            <tr>
                                <th colSpan={2}><AreaSelect /></th>
                                <th>2024년 01월 기준</th>
                            </tr>
                            <tr><th>총인구</th><th>취약 인구</th><th>도시 면적</th></tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    { infoData[infoCode].POP.comma(3) }<span>명</span>
                                </td>
                                <td>
                                    { infoData[infoCode].VUL.comma(3) }<span>명</span>
                                </td>
                                <td>
                                    { infoData[infoCode].AREA.comma(3) }<span>㎢</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            /* Local public information finish */ }

            { /* Area choice start */
            <div id={ style.gfas_area_box }>
                <label onClick={() => { 
                    if (area !== 'SGG') {
                        setArea('SGG');
                        setInfoCode('42000');
                        closePopup();
                    }
                }} 
                className={ (area === 'SGG') ? style.gfas_ab_class_pick : style.gfas_ab_class_wait  }>
                    <Radio checked={ area === 'SGG' } name="gfas_ab_name_year" size="small"  
                    sx={{ color: "#FFFFFF80", '&.Mui-checked': { color: "#FFFFFFFF" }}} />행정 구역
                </label>
                <label onClick={() => { 
                    if (area !== 'TB') {
                        setArea('TB');
                        setInfoCode('42000');
                        closePopup();
                    }
                }} 
                className={ (area === 'TB') ? style.gfas_ab_class_pick : style.gfas_ab_class_wait  }>
                    <Radio checked={ area === 'TB' } name="gfas_ab_name_year" size="small"
                    sx={{ color: "#FFFFFF80", '&.Mui-checked': { color: "#FFFFFFFF" }}} />특보 구역
                </label>
            </div>
            /* Area choice finish */ }

            { /* Features to be added start */
            <div id={ style.gfas_add_features}>

                {/* 강원 지하차도 
                <button className={ mapSwitch.under === true ? style.gfas_af_btn_class_on : style.gfas_af_btn_class_off }
                onClick={() => { setMapSwitch({ ...mapSwitch, under: (mapSwitch.under === true) ? false : true }) }}>
                    <div>지하차도</div><IconTunnel xmlns='http://www.w3.org/2000/svg' viewBox="0 0 200 200" />
                </button>
                */}

                {/* 예측 
                <button className={ currentStatus === 0 ? style.gfas_af_btn_class_on : style.gfas_af_btn_class_off }
                onClick={() => { setCurrentStatus(0) }}>
                    <div>예측</div>
                    <IconPre xmlns='http://www.w3.org/2000/svg' viewBox="0 0 512 512" />
                </button>

                관측 
                <button className={ currentStatus === 1 ? style.gfas_af_btn_class_on : style.gfas_af_btn_class_off }
                onClick={() => { 
                    setCurrentStatus(1); 
                    setPlayAction(false); 
                    clockPlayStop();
                    setPointTime(0);
                }}>
                    <div>관측</div>
                    <IconObs xmlns='http://www.w3.org/2000/svg' viewBox="0 0 512 512" />
                </button> */}

                {/* 1Km */}
                <button className={ gridBoolean === true ? style.gfas_af_btn_class_on : style.gfas_af_btn_class_off } 
                onClick={() => { 
                    setGridBoolean(gridBoolean === true ? false : true );
                    if (gridBoolean === false) closePopup();
                }}>
                    <div>1km</div>
                    { gridBoolean === true ?  <GridOff /> : <GridOn /> }
                </button>

                 {/* 우량주상도 */}
                 <button className={ style.gfas_af_btn_class_toggle } 
                onClick={() => { 
                    //setFallWall(true);
                    if (playAction === true) {
                        setPlayAction(false);
                        clockPlayStop();
                    }

                    const geo = window.geometry();
                    // console.log(geo.windowsX);
                    const top = (geo.windowsY) ? geo.windowsY + 151 : 151;
                    const left = (geo.windowsX) ? geo.windowsX + 635 : 635;
                     
                    $('[element="gfas_Sit_select"] option:selected').text();
                    const url = window.location.href + '#/Hyeto?date='+ crtn.date + '&time=' + crtn.time
                              + '&name=' + $('[element="gfas_Sit_select"] option:selected').text();
                    window.open(url, '', 'top=' + top +', left=' + left + ', width=600, height=561, scrollbars=0')
                }}>
                   <div>우량주상도</div><IconRainfall xmlns='http://www.w3.org/2000/svg' viewBox="0 0 200 200" />
                </button>

                {/* 강원 도로 */}
                <button className={ mapSwitch.road === true ? style.gfas_af_btn_class_on : style.gfas_af_btn_class_off }
                onClick={() => { setMapSwitch({ ...mapSwitch, road: (mapSwitch.road === true) ? false : true }) }}>
                    <div>도로<br />지하차도</div>
                    <IconTunnel xmlns='http://www.w3.org/2000/svg' viewBox="0 0 200 200" id={ style.gfas_add_tunnel } />
                </button>

                {/* 위성 지도 */}
                <button className={ mapSwitch.satellite === true ? style.gfas_af_btn_class_on : style.gfas_af_btn_class_off }
                onClick={() => { setMapSwitch({ ...mapSwitch, satellite: (mapSwitch.satellite === true) ? false : true }) }}>
                    <div>위성지도</div><IconSatellite xmlns='http://www.w3.org/2000/svg' viewBox="0 0 512 512" />
                </button>
            </div>
            /* Features to be added start */ }

            { /* CCTV start */
            cctvData.length > 0 &&
                <ul id={ style.gfas_cctv_box }>
                    <li>CCTV</li>
                    <li><SelectCctv /></li>
                </ul>
            /* CCTV finish */}

            { /* 취약인구 그래프 시작 */
            Object.keys(infoData).length > 0 &&
                <div id={ style.gfas_vulnerable_chart }>
                    <Highchart1 POP={ infoData[infoCode].POP } VUL={ infoData[infoCode].VUL } />
                </div>
             /* 취약인구 그래프 시작 */}

            { /* 침수 위험지역 시작 */
            Object.keys(floodData).length > 0 &&
            <div id={ style.gfas_flood_container }>
                <table id={ style.gfas_fc_table }>
                    <tbody>
                    <tr>
                        <td colSpan={4}>
                            { new Date(fcst.date + ' ' + fcst.time).format('Y년 m월 d일 h시') }
                            &nbsp;호우 재해 영향 위험&nbsp;
                            { gridBoolean === true ?
                                '격자 (1km)'
                            : 
                                area === 'SGG' ? '시군' : '특보 구역'
                            }
                        </td>
                    </tr>
                    <tr>
                        <td>관심</td><td>주의</td><td>경고</td><td>위험</td>
                    </tr>
                    <tr>
                        <td>{ floodData.LEVEL_01[pointTime].comma(3) }</td>
                        <td>{ floodData.LEVEL_02[pointTime].comma(3) }</td>
                        <td>{ floodData.LEVEL_03[pointTime].comma(3) }</td>
                        <td>{ floodData.LEVEL_04[pointTime].comma(3) }</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            /* 침수 위험지역 종료 */ }

            { /* Base map legend start */
            <div id={ style.gfas_base_legend }>
                <div id={ style.gfas_bl_reative }>
                    <table id={ style.gfas_bl_table }>
                        <tbody>
                        <tr>
                            <td colSpan={4}>
                                <div>호우 재해 영향 위험등급 범례</div>
                                <div>{ infoCode !== '42000' && '\u00A0(' + $('[element="gfas_Sit_select"] option:selected').text() + ')' }</div>
                            </td>
                        </tr>
                        <tr>
                            <td>관심</td>
                            <td>주의</td>
                            <td>경고</td>
                            <td>위험</td>
                        </tr>
                        </tbody>
                    </table>

                    <div id={ style.gfas_bl_boundary_01 } className={ style.gfas_bl_class_boundary }></div>
                    <div id={ style.gfas_bl_boundary_02 } className={ style.gfas_bl_class_boundary }></div>
                    <div id={ style.gfas_bl_boundary_03 } className={ style.gfas_bl_class_boundary }></div>

                    { infoCode !== '42000' &&<>
                        <ul id={ style.gfas_bl_division } className={ style.gfas_bl_class_value }>
                            <li>&nbsp;</li>
                            <li>AMC 1</li>
                            <li>AMC 2</li>
                            <li>AMC 3</li>
                        </ul>

                        <ul id={ style.gfas_bl_value_01 } className={ style.gfas_bl_class_value }>
                            <li>보행</li>
                            <li>{ thrLegend[area][infoCode][0][0] }mm</li>
                            <li>{ thrLegend[area][infoCode][0][1] }mm</li>
                            <li>{ thrLegend[area][infoCode][0][2] }mm</li>
                        </ul>
                        <ul id={ style.gfas_bl_value_02 } className={ style.gfas_bl_class_value }>
                            <li>교통</li>
                            <li>{ thrLegend[area][infoCode][1][0] }mm</li>
                            <li>{ thrLegend[area][infoCode][1][1] }mm</li>
                            <li>{ thrLegend[area][infoCode][1][2] }mm</li>
                        </ul>
                        <ul id={ style.gfas_bl_value_03 } className={ style.gfas_bl_class_value }>
                            <li>건물</li>
                            <li>{ thrLegend[area][infoCode][2][0] }mm</li>
                            <li>{ thrLegend[area][infoCode][2][1] }mm</li>
                            <li>{ thrLegend[area][infoCode][2][2] }mm</li>
                        </ul>
                    </>}
                    
                    <Walk id={ style.gfas_bl_walk } className={ style.gfas_bl_class_element } />
                    <Car id={ style.gfas_bl_car } className={ style.gfas_bl_class_element } />
                    <House id={ style.gfas_bl_house } className={ style.gfas_bl_class_element } />

                    <div id={ style.gfas_bl_depth_01 } className={ style.gfas_bl_class_depth }></div>
                    <div id={ style.gfas_bl_depth_02 } className={ style.gfas_bl_class_depth }></div>
                    <div id={ style.gfas_bl_depth_03 } className={ style.gfas_bl_class_depth }></div>
                </div>
            </div>
            /* Base map legend finish */ }

            { /* Fall map legend start */
            <div id={ style.gfas_fall_legend }>
                <div id={ style.gfas_fl_unit }>㎜/<span>h</span></div>
                <FallLegend />
            </div>
            /* Fall map legend finish */ }

            { /* 경고문 시작 */
            <div id={ style.gfas_annotation }>※ 본 R2MAPS의 호우재해영향위험등급은 기상청 공식입장과는 무관함을 밝힙니다.</div>
            /* 경고문 종료 */ }

            { /* Copyright & Developed start */ }
            <div id={ style.gfas_copyright }>Copyright &copy; AI for Climate & Disaster Management Center. All Rights RESERVED</div>
            <div id={ style.gfas_developed }>Developed at ECOBRAIN Co.,Ltd</div>
            { /* Copyright & Developed finish */ }

            { fallWall === true && /* 우량주상도 시작 */
            <div id={ style.gfas_fall_wall }>
                <div id={ style.gfas_fall_conteiner }>
                    <button id={ style.gfas_tran_close } onClick={() => { setFallWall(false) }} title='Close the chart'></button>
                    <button id={ style.gfas_fall_close } onClick={() => { setFallWall(false) }} title='Close the chart'>✕</button>
                    <div id={ style.gfas_fall_chart }>
                        <Highchart2 crtn={ crtn } infoCode={ infoCode } />
                    </div>
                </div>
            </div>
            /* 우량주상도 시작 */}

            { /* 1km popup start */
            <div id="popup" className={ style.gfas_class_ol_popup }>
                <ul id={ style.gfas_op_ul }>
                    <li>
                        예측 강우량 
                        <Close id={ style.gfas_opu_close } 
                        onClick={() => { 
                            $('#popup').hide();
                            baseGround.removeOverlay();
                        }}/>
                    </li>
                    <li>{ Object.keys(pcpData).length > 0 && pcpData[infoCode][pointTime].toFixed(1) }<span>mm/3h</span></li>
                </ul>
            </div>
            /* 1km popup finish */}
        </section>
    
        { (loading === true || cctvUrl !== null) &&
        <section id="_back_wall">
            { loading === true &&
                <div id="_loading_section" className='_ml_class_loader' />
            }
            { cctvUrl !== null &&
                <div id={ style.cctv_container }>
                     <VideoPlayer cctvName={ cctvName } cctvUrl={ cctvUrl } procCctvUrl={ procCctvUrl } />
                </div>
            }
        </section>
        }
    </>)
}

export default Intro;